import axiosClient from "../../common/axios/axiosConfig";
import useQuery from "../../utils/useQuery";

export const deletePatientToQueue = async (
  id: string,
  patientId: string,
): Promise<boolean> => {
  try {
    const urlSearchParams = useQuery();
    const telemedicineToken = urlSearchParams.get("token") || "";

    const response = await axiosClient.delete(`/room/delete/${id}/waiting/${patientId}`, {
      headers: {
        Authorization: `Bearer ${telemedicineToken}`,
      },
    });

    return response.data.success === true;
  } catch (err: any) {
    if (err?.response?.status === 404) {
      return false;
    }

    console.error("Erro ao remover paciente da fila de espera:", err);
    return false;
  }
};
